import React from 'react';
import DirectNavigationModel from '../DirectNavigationModel';
import {PropTypes} from 'prop-types';
import SpacesView from '../SpacesView/SpacesView.react.js';
import {Button} from '@homeaway/react-buttons';
import UIHelper from 'virtual-tour-viewer/src/utils/UIHelper';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__24, CHEVRON_UP__24} from '@homeaway/svg-defs';

import './GroupView.less';
import LocaleContext from '../../../../../Contexts/Locale/Context';
import withLifecycleLogging from '../../../hoc/WithLifecycleLogging.react';
import LoggingPropTypes from '../../../../../Contexts/Logging/PropTypes';
import withLog from '../../../hoc/WithLog.react';
import AbacusContext from '../../../../../Contexts/Abacus/Context';

class GroupView extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    _onGroupClick = () => {
        if (this.props.onGroupClick) {
            this.props.onGroupClick(this.props.group);
        }

        if (this.props.log) {
            this.props.log.info('GroupView.onGroupClick', {props: this.props, state: this.state});
        }
    };

    _onSpaceClick = (space) => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(space, this.props.group);
        }
    };

    _getImageUrl = (group, useMediaGateway) => {
        const imageName = useMediaGateway
            ? group.landingSphere.mediaGatewayURL
            : group.landingSphere.imageURI;
        return UIHelper.getImageUrlFromName(imageName, 'q2', useMediaGateway);
    };

    render() {
        let {group, useMediaGateway, withGroupLabel} = this.props;
        return (
            <li className={`Group`}>
                {withGroupLabel && (
                    <LocaleContext.Consumer>
                        {(getTranslation) => (
                            <AbacusContext.Consumer>
                                {(experiments) => {
                                    return (
                                        <Button
                                            disabled={group.active && !!group.landingSphere}
                                            onClick={this._onGroupClick}
                                            label={
                                                <React.Fragment>
                                                    {group.landingSphere ? (
                                                        <img
                                                            src={this._getImageUrl(
                                                                group,
                                                                useMediaGateway
                                                            )}
                                                            className={'img-rounded'}
                                                        />
                                                    ) : null}
                                                    <div className="GroupName">
                                                        {getTranslation(
                                                            'groupLabels',
                                                            group.groupType
                                                        )}
                                                    </div>
                                                    {group.active ? (
                                                        <SVGIcon
                                                            markup={CHEVRON_UP__24}
                                                            strokeWidth={2}
                                                        />
                                                    ) : (
                                                        <SVGIcon
                                                            markup={CHEVRON_DOWN__24}
                                                            strokeWidth={2}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            }
                                        />
                                    );
                                }}
                            </AbacusContext.Consumer>
                        )}
                    </LocaleContext.Consumer>
                )}
                {group.active && group.spaces && group.spaces.length ? (
                    <SpacesView
                        spaces={group.spaces}
                        onSpaceClick={this._onSpaceClick}
                        useMediaGateway={useMediaGateway}
                    />
                ) : null}
            </li>
        );
    }
}

GroupView.propTypes = {
    group: DirectNavigationModel.groupType.isRequired,
    log: PropTypes.shape(LoggingPropTypes),
    onGroupClick: PropTypes.func,
    onSpaceClick: PropTypes.func,
    withGroupLabel: PropTypes.bool,
    useMediaGateway: PropTypes.bool,
};

export default withLog(withLifecycleLogging(GroupView));
